var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-select",
      class: {
        "c-select_reverse": _vm.reverse !== undefined,
      },
    },
    [
      _c("div", { staticClass: "c-select__wrapper" }, [
        _vm.label
          ? _c("div", { staticClass: "c-select__label" }, [
              _vm._v(_vm._s(_vm.label)),
            ])
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "c-select__select",
            class: {
              "c-select__select-required":
                Array.isArray(_vm.valueLocal) &&
                _vm.valueLocal.length === 0 &&
                _vm.required,
            },
          },
          [
            _c("v-select", {
              attrs: {
                components: _vm.components,
                options: _vm.items,
                clearable: _vm.clearable !== undefined,
                searchable: _vm.searchable !== undefined,
                placeholder: _vm.placeholder,
                multiple: _vm.multiple !== undefined,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "no-options",
                    fn: function ({ searching }) {
                      return [
                        searching
                          ? [_vm._v(" Совпадений не найдено ")]
                          : _vm._e(),
                      ]
                    },
                  },
                  _vm.required !== undefined
                    ? {
                        key: "footer",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "notice",
                                class: {
                                  notice_hidden:
                                    _vm.multiple !== undefined
                                      ? _vm.valueLocal.length !== 0
                                      : _vm.valueLocal !== null,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "notice__icon" },
                                  [_c("c-icon", { attrs: { icon: "notice" } })],
                                  1
                                ),
                                _c("div", { staticClass: "notice__text" }, [
                                  _vm._v(_vm._s(_vm.required)),
                                ]),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      }
                    : null,
                  {
                    key: "option",
                    fn: function (option) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "c-select__option",
                            class: {
                              "c-select__option_selected": _vm.value
                                ? _vm.isSelected(option.value)
                                : false,
                              "c-select__option_avatar": option.avatar,
                            },
                          },
                          [
                            option.avatar
                              ? _c("div", {
                                  staticClass: "c-select__option-avatar",
                                  style: {
                                    "background-image": `url(${option.avatar})`,
                                  },
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "c-select__option-label" },
                              [_vm._v(_vm._s(option.label))]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
              model: {
                value: _vm.valueLocal,
                callback: function ($$v) {
                  _vm.valueLocal = $$v
                },
                expression: "valueLocal",
              },
            }),
          ],
          1
        ),
        _vm.reverse !== undefined && _vm.multiple !== undefined
          ? _c(
              "div",
              { staticClass: "c-select__reverse" },
              [
                _c("c-switcher", {
                  attrs: {
                    label: "Все кроме",
                    type: "checkbox",
                    disabled: _vm.valueLocal.length === 0,
                  },
                  model: {
                    value: _vm.reverseLocal,
                    callback: function ($$v) {
                      _vm.reverseLocal = $$v
                    },
                    expression: "reverseLocal",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }